import { render, staticRenderFns } from "./AppsIntegrationsPopoverItem.vue?vue&type=template&id=024aacfb&"
import script from "./AppsIntegrationsPopoverItem.vue?vue&type=script&lang=js&"
export * from "./AppsIntegrationsPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports